/**
 * ONE AI 써드파티 위젯 호출 유틸.
 *
 * 써드파티헤더(wehago.global.live.js)가 로드하는 one-ai 번들이 window에 전역 함수를 주입한다.
 *   - window.useOneAI(open, isNewChat, question, options): 위젯 열기 + 질문 자동 전송.
 *     options.rtcRoomId를 주면 ONE AI가 화상회의 STT 컨텍스트(search_type=3, room_id)로 질의한다.
 *   - window.openWehagoAiBot(): 위젯 열기만 (질문 전송 불가 구버전 폴백)
 *
 * 전역 타입 선언은 components/Footer/buttons/OneAiButton.tsx의 declare global 참고.
 */

/**
 * ONE AI 패널을 열고 프롬프트를 자동입력·전송한다.
 * @returns 패널 열기에 성공했으면 true (프롬프트 전송 여부와 무관)
 */
export const openOneAiWithPrompt = (prompt: string, rtcRoomId?: string): boolean => {
  try {
    // 써드파티헤더가 아직 배포 여부를 못 받아온 상태면 열지 않는다 (기존 OneAiButton과 동일 가드)
    if (typeof window.isOneAIDeploy === 'function' && !window.isOneAIDeploy()) {
      return false;
    }

    if (typeof window.useOneAI === 'function') {
      window.useOneAI(true, true, prompt, rtcRoomId ? { rtcRoomId } : {});
      return true;
    }

    // 구버전 헤더 폴백: 패널만 연다 (프롬프트 자동 전송 미지원)
    if (typeof window.openWehagoAiBot === 'function') {
      console.warn('[OneAI] window.useOneAI 미지원 헤더 — 패널만 엽니다.');
      window.openWehagoAiBot();
      return true;
    }
  } catch (err) {
    console.warn('[OneAI] 자동 프롬프트 호출 실패:', err);
  }
  return false;
};
